<template>
  <div class="homecare-topic-insulin-area">
    <div v-for="(pageRow, pageIndex) in listPage" class="page print-info-area fs13 p20 mb-4" :key="pageIndex">
      <PDFHeader :title="$t('home_care_notebook')"/>
      <div class="bodyPDF">
        <div class="detail-content-area">
          <p v-if="pageIndex == 0" class="title-table">{{tableTitle}}</p>
          <div v-if="pageIndex == 0" class="list-time-area">
            <ul>
              <li class="pl-3 pr-3">更新日：{{dataTabFormatted.date}}</li>
            </ul>
          </div>
          <div v-for="(row, rowIndex) in pageRow" :class="['home-care-table', tableName]" :key="rowIndex">
            <div v-if="row.type === 'image'" class="table-image-area">
              <div :class="['title-list-image', (rowIndex != 0 ? 'border-top-0' : '')]">{{row.colTitle}}</div>
              <div class="list-image">
                <p v-if="row.rowData == null">画像のデータがありません</p>
                <template v-else>
                  <img
                    v-for="(img_url, index) in row.rowData"
                    :key="'insulin_img_'+index"
                    :src="img_url"
                    :style="[(row.rowData.length == 1 ? {maxWidth: '100%'} : ''), { maxHeight: '690px' }]"
                  />
                </template>
              </div>
            </div>
            <table v-if="row.type === 'table'" :class="rowIndex == 0 ? '' : 'table-border-top-none'">
              <!-- insulin basic -->
              <tr v-if="dataTabFormatted.route_through_insulin === basicInsulin">
                <!-- if row is other data -->
                  <template v-if="row.rowData[0].colName === 'administration_time_other_basic'">
                    <td>{{`${row.rowData[0].colTitle}(${getInsulinUnit(row.rowData[0].colData, 0)})`}}</td>
                    <td colspan="3">{{getInsulinUnit(row.rowData[0].colData, 1)}}</td>
                  </template>
                  <!-- if row is basic data -->
                  <template v-else>
                    <td>{{row.rowData[0].colTitle}}</td>
                    <td :colspan="row.rowData[1] ? 1 : 3">
                      {{
                        row.rowData[0].colName === 'route_through_insulin'
                        ? row.rowData[0].colData
                        : getInsulinUnit(row.rowData[0].colData)
                      }}
                    </td>
                  </template>
                <!-- if have the 3rd and 4th col -->
                <template v-if="row.rowData[1]">
                  <td>{{row.rowData[1].colTitle}}</td>
                  <td>{{getInsulinUnit(row.rowData[1].colData)}}</td>
                </template>
              </tr>
              <!-- end insulin basic -->
              <!-- insulin scale -->
              <tr :class="row.colName" v-else-if="dataTabFormatted.route_through_insulin === scaleInsulin">
                <!-- if row just have title -->
                <template v-if="row.isTitle">
                    <td colspan="4">{{row.colTitle}}</td>
                </template>
                <!-- if row have title and data -->
                <template v-else>
                  <!-- if row is other data -->
                  <template v-if="row.rowData[0].colName === 'administration_time_other_scale'">
                    <td>{{`${row.rowData[0].colTitle}(${getInsulinUnit(row.rowData[0].colData, 0)})`}}</td>
                    <td colspan="3">{{getInsulinUnit(row.rowData[0].colData, 1)}}</td>
                  </template>
                  <!-- if row is scale data -->
                  <template v-else>
                    <td>{{row.rowData[0].colTitle}}</td>
                    <td :colspan="row.rowData[1] ? 1 : 3">
                      {{
                        row.rowData[0].colName === 'route_through_insulin'
                        ? row.rowData[0].colData
                        : getInsulinUnit(row.rowData[0].colData)
                      }}
                    </td>
                    <!-- if have the 3rd and 4th col -->
                    <template v-if="row.rowData[1]">
                      <td>{{row.rowData[1].colTitle}}</td>
                      <td>{{getInsulinUnit(row.rowData[1].colData)}}</td>
                    </template>
                  </template>
                </template>
              </tr>
              <!-- end insulin scale -->
              <tr v-else>
                <td>{{row.rowData[0].colTitle}}</td>
                <td :colspan="3">{{row.rowData[0].colData}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const HEIGHT_OF_SPACE_AREA = 958 // height of paper - padding top bottom - header - endline = 1123 - 40 - 110 - 15
const HEIGHT_OF_SPACE_AREA_FIRST_PAGE = 931 // height of paper - padding top bottom - header - endline = 1123 - 40 - 110 - 42
const MAX_HEIGHT_OF_TITLE_ROW = 140
import PDFHeader from '../PDFHeader.vue'
import { getHomecareInsulinUnit, HEIGHT_DEFAULT_OF_IMAGE_AREA, HEIGHT_OF_ROW_WITHOUT_DATA, HEIGHT_OF_TITLE_ROW } from '@/js/commons/commons'
export default {
  components: {
    PDFHeader,
  },
  props: [
    'tableName',
    'tableTitle',
    'listColumnTable',
    'dataTabFormatted'
  ],
  data() {
    return {
      listPage: [],
      pageIndex: 0,
      spaceArea: HEIGHT_OF_SPACE_AREA_FIRST_PAGE,
      insulinFomulation: {
        key: 'attach_images_insulin_formulation',
        value: 'インスリン製剤'
      },
      insulinPump: {
        key: 'attach_images_insulin_pump',
        value: 'インスリンポンプ(持続)'
      },
      basicInsulin: 'ペン型(基本)',
      scaleInsulin: 'ペン型(スケール)',

    }
  },
  created() {
    this.splitTableToManyPage()
  },
  async mounted() {
    await Promise.all(Array.from(document.querySelectorAll('.homecare-topic-insulin-area img')).map(img => {
      if (img.complete)
        return Promise.resolve(img.naturalHeight !== 0);
      return new Promise(resolve => {
        img.addEventListener('load', () => resolve(true));
        img.addEventListener('error', () => resolve(false));
      });
    })).then(results => {
      if (results.every(res => res)) {
        setTimeout(() => {
          this.mergePage()
        }, 10);
      }
    });
  },
  methods: {
    mergePage() {
      let previousInsulinPage = null
      Array.from(document.querySelectorAll('.homecare-topic-insulin-area .page')).forEach(insulinPage => {
        let shouldSkip = false;
        if(previousInsulinPage) {
          let isPreviousInsulinHaveImage = (previousInsulinPage && previousInsulinPage.getElementsByTagName('img').length > 0)
          let listRowEl = Array.from(insulinPage.querySelectorAll('.insulin'))
          let previousBody = previousInsulinPage.querySelector('.bodyPDF')
          let isTableTitle = false
          listRowEl.forEach((rowEl, index) => {
            if (shouldSkip) {
              return;
            }
            let isRowHaveImage =  rowEl.getElementsByTagName('img').length > 0
            isTableTitle = rowEl.getElementsByTagName('td').length == 1
            if(previousBody.offsetHeight + rowEl.offsetHeight <= HEIGHT_OF_SPACE_AREA_FIRST_PAGE && !(isPreviousInsulinHaveImage && isRowHaveImage)) {
              if(isTableTitle) {
                let titleName = rowEl.getElementsByTagName('tr')[0].className
                let isTitleAlreadyExists = previousBody.getElementsByClassName(titleName).length > 0
                let nextRowElHeight = (index < listRowEl.length - 1) ? listRowEl[index+1].offsetHeight : 0
                if(
                  !isTitleAlreadyExists 
                  && previousBody.offsetHeight + rowEl.offsetHeight + nextRowElHeight <= HEIGHT_OF_SPACE_AREA_FIRST_PAGE
                ) {
                  let elClone = rowEl.cloneNode(true)
                  elClone.children[0].classList.add('table-border-top-none')
                  previousBody.children[0].insertAdjacentElement('beforeEnd', elClone)
                }
                else if (previousBody.offsetHeight + rowEl.offsetHeight + nextRowElHeight > HEIGHT_OF_SPACE_AREA_FIRST_PAGE) {
                  rowEl.children[0].classList.remove("table-border-top-none")
                  shouldSkip = true;
                  return;
                }
                rowEl.children[0].classList.remove("table-border-top-none")
                rowEl.classList.add('table-title-checking')
              }
              else {
                let tableTitleChecking = document.getElementsByClassName('table-title-checking')
                if(rowEl.getElementsByTagName('td').length == 2) {
                  tableTitleChecking.length > 0 ? tableTitleChecking[0].parentNode.removeChild(tableTitleChecking[0]) : null
                }
                rowEl.children[0].classList.add("border-top-0")
                rowEl.children[0].classList.add("table-border-top-none")
                previousBody.children[0].insertAdjacentElement('beforeEnd', rowEl)
              }
            }
            else {
              rowEl.children[0].classList.remove("border-top-0")
              shouldSkip = true;
              return;           
            }
          })
        }
        if(insulinPage.querySelector('.detail-content-area').children.length == 0) {
          insulinPage.remove()
          previousInsulinPage = null
        }
        else {
          previousInsulinPage = insulinPage
        }
      })
    },
    splitTableToManyPage() {
      let heightThisRow = HEIGHT_DEFAULT_OF_IMAGE_AREA
      let chuck = 2
      this.listPage.push([])
      //split page with the first list image
      if(this.dataTabFormatted[this.insulinFomulation.key] == null) {
        heightThisRow = HEIGHT_OF_TITLE_ROW + HEIGHT_OF_ROW_WITHOUT_DATA
        this.listPage[this.pageIndex].push({type: 'image', colName: this.insulinFomulation.key, colTitle: this.insulinFomulation.value, rowData: null})
      }
      else {
        for (let i = 0; i < this.dataTabFormatted[this.insulinFomulation.key].length; i += chuck) {
          let rowData = this.dataTabFormatted[this.insulinFomulation.key].slice(i, i + chuck)
          this.listPage[this.pageIndex].push({type: 'image', colName: this.insulinFomulation.key, colTitle: this.insulinFomulation.value, rowData: rowData})
          if(i + chuck < this.dataTabFormatted[this.insulinFomulation.key].length) {
            this.listPage.push([])
            this.pageIndex++
          }
        }
        heightThisRow = HEIGHT_DEFAULT_OF_IMAGE_AREA
      }
      this.spaceArea -= heightThisRow
      //end split page with the first list image
      this.spaceArea -= HEIGHT_OF_TITLE_ROW
      this.listPage[this.pageIndex].push({
        type: 'table',
        rowData:[{colName: 'route_through_insulin', colTitle: '投与経路', colData: (this.dataTabFormatted.route_through_insulin || 'ー')}],
      })
      switch (this.dataTabFormatted.route_through_insulin) {
        //Insulin pump continuous
        case this.insulinPump.value:
          this.handlePumpTable()
          break;
        //pen type basic
        case this.basicInsulin:
          this.handleBasicTable()
          break;
        // pen type scale
        case this.scaleInsulin:
          this.handleScaleTable()
          break;
        default:
          break;
      }
    },
    checkAddPage(heightAdded, callback=()=>{}) {
      if(this.spaceArea < 0) {
        this.listPage.push([])
        this.pageIndex++
        this.spaceArea = HEIGHT_OF_SPACE_AREA - heightAdded
        callback()
      }
    },
    handlePumpTable() {
      let chuck = 2
      if(this.dataTabFormatted[this.insulinPump.key] == null) {
        this.spaceArea -= HEIGHT_OF_ROW_WITHOUT_DATA
        this.checkAddPage(HEIGHT_OF_ROW_WITHOUT_DATA)
        this.listPage[this.pageIndex].push({type: 'image', colName: this.insulinPump.key, colTitle: this.insulinPump.value, rowData: null})
      }
      else {
        this.spaceArea -= HEIGHT_DEFAULT_OF_IMAGE_AREA
        this.checkAddPage(HEIGHT_DEFAULT_OF_IMAGE_AREA)
        for(let i = 0; i < this.dataTabFormatted[this.insulinPump.key].length; i += chuck) {
          let rowData = this.dataTabFormatted[this.insulinPump.key].slice(i, i + chuck)
          this.listPage[this.pageIndex].push({type: 'image', colName: this.insulinPump.key, colTitle: this.insulinPump.value, rowData: rowData})
          if(i + chuck < this.dataTabFormatted[this.insulinPump.key].length) {
            this.listPage.push([])
            this.pageIndex++
          }
        }
      }
    },
    handleBasicTable() {
      this.listColumnTable.type_basic.forEach(row => {
        if(Object.keys(row)[0] === 'administration_time_other_basic') {
          this.spaceArea -= MAX_HEIGHT_OF_TITLE_ROW
          this.checkAddPage(MAX_HEIGHT_OF_TITLE_ROW)
        }
        else {
          this.spaceArea -= HEIGHT_OF_TITLE_ROW
          this.checkAddPage(HEIGHT_OF_TITLE_ROW)
        }
        let rowData = []
        for (const [key, value] of Object.entries(row)) {
          rowData.push({colName: key, colTitle: value, colData: this.dataTabFormatted[key]})
        }
        this.listPage[this.pageIndex].push({type: 'table', rowData: rowData})
      })
    },
    handleScaleTable() {
      let scale = ['80mg/dl以下', '81mg/dl 〜 199mg/dl', '200mg/dl 〜 349mg/dl', '350mg/dl 〜 449mg/dl', '450mg/dl以上']
      for (const [key, value] of Object.entries(this.listColumnTable.type_scale)) {
        this.spaceArea -= HEIGHT_OF_TITLE_ROW
        this.checkAddPage(HEIGHT_OF_TITLE_ROW)
        this.listPage[this.pageIndex].push({type: 'table', isTitle: true, colName: key, colTitle: value})
        if(key === 'administration_time_other_scale') {
          this.listPage[this.pageIndex].push({
            type: 'table',
            rowData: [{colName: key, colTitle: value, colData: this.dataTabFormatted[key]}]
          })
        }
        else {
          for(let i = 0; i < 5 ; i += 2) {
            this.spaceArea -= HEIGHT_OF_TITLE_ROW
            this.checkAddPage(
              HEIGHT_OF_TITLE_ROW,
              () => {this.listPage[this.pageIndex].push({type: 'table', isTitle: true, colName: key, colTitle: value})}
            )
            let rowData = [{colName: key+'-'+i, colTitle: scale[i], colData: this.dataTabFormatted[key][i]}]
            if(i+1 < 5) {
              rowData.push({colName: key+'-'+(i+1), colTitle: scale[i+1], colData: this.dataTabFormatted[key][i+1]})
            }
            this.listPage[this.pageIndex].push({type: 'table', rowData: rowData})
          }
        }
      }
    },
    getInsulinUnit(data, index = null) {
      return getHomecareInsulinUnit(data, index)
    },
  }
}
</script>
<style scoped>
  .table-border-top-none {
    border-top: 0 !important;
  }
  .table-border-top-none tr td{
    border-top: 0 !important;
  }
  .homecare-topic-area .home-care-table tr td:nth-child(odd) {
    min-width: 165px !important;
    max-width: 165px !important;
  }
  .homecare-topic-area .home-care-table table tr td {
    min-width: 211px !important;
    max-width: 211px !important;
  }
  .list-image {
    max-height: 900px;
  }
</style>
